// WordPress dependencies
import { createRoot, render } from '@wordpress/element';

// Internal dependencies
import EditPost from './components/EditPost';

function App() {
	// const params = new URLSearchParams( document.location.search );
	// const page = params.get( 'page' );

	let PageComponent = null;
	if ( document.body.classList.contains( 'post-type-coca_bais' ) ) {
		PageComponent = EditPost;
	}

	return <PageComponent />;
}

window.addEventListener(
	'load',
	function() {
		const editorRootId = '#coca_bais__edit_panel_root';
		if ( document.querySelector( editorRootId ) ) {
			// render components in reactjs 18
			if ( typeof createRoot === 'function' ) {
				const root = createRoot(
					document.querySelector( editorRootId )
				);
				root.render( <App /> );
			} else {
				// render components in reactjs 17
				render( <App />, document.querySelector( editorRootId ) );
			}
		}
	},
	false
);
